module.exports = __webpack_public_path__ + "static/media/delivery-blue.2ddcde96.svg";